import React from 'react';
import './index.scss';

const LoaderLogo = () => {
  return (
    <div className="ergo-loader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="59"
        height="59"
        viewBox="0 0 59 59"
        fill="none"
      >
        <path
          d="M29.8011 59C29.6868 59 29.5679 58.988 29.452 58.9654C29.3377 58.9443 29.2234 58.9097 29.115 58.8661L9.47084 50.981C9.24366 50.8892 9.03902 50.7554 8.8675 50.5869C8.69749 50.4199 8.55905 50.2182 8.46427 49.9926L0.148981 30.5258C0.100837 30.4145 0.0646582 30.2987 0.0390817 30.1798C0.0150097 30.064 0.00146924 29.9436 0.00146924 29.8218L0 29.7992C0.0015045 29.6804 0.012033 29.563 0.0346005 29.4501C0.057168 29.3358 0.0902552 29.2215 0.13539 29.1116L8.02049 9.47043C8.11076 9.24325 8.24618 9.03864 8.41468 8.86562C8.58168 8.69561 8.78324 8.55717 9.00892 8.46239L28.4741 0.148566C28.5869 0.100422 28.7028 0.0643173 28.8202 0.0387408C28.9375 0.0146689 29.0594 0.00112837 29.1812 0.00112837C29.1842 -0.000376124 29.2114 -0.000376124 29.2144 0.00112837C29.3302 0.00112837 29.4461 0.0131614 29.5559 0.0357289C29.6687 0.0567919 29.7786 0.0898761 29.8884 0.133507L49.5311 8.0186C49.7583 8.11038 49.9629 8.24422 50.1344 8.41273C50.3059 8.57973 50.4428 8.78136 50.5391 9.00703L58.853 28.4707C58.9493 28.6964 58.9989 28.9371 59.0019 29.1778C59.0034 29.417 58.9583 29.6578 58.8665 29.885L50.9814 49.5277C50.8911 49.7549 50.7558 49.9594 50.5873 50.131C50.4203 50.3025 50.2186 50.4409 49.9944 50.5357L30.5293 58.8496C30.4134 58.8992 30.2946 58.9368 30.1742 58.9608C30.0478 58.9864 29.923 59 29.8011 59V59ZM12.6559 46.7203L29.7635 53.5868L46.7177 46.3472L53.5857 29.2395L46.346 12.2868L29.2384 5.41732L12.2812 12.6599L5.41318 29.7676L12.6559 46.7203V46.7203Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6272 37.0656H39.0463V42.372H19.9558V37.5485L27.4677 29.2332L19.9919 21.4429V16.606H39.0463V21.9108H27.871L34.7991 29.167L27.6272 37.0656Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default LoaderLogo;
